module.exports = __webpack_public_path__ + "static/media/LAUNDRY - 2020 NOVO PORTI.9853be44.pdf";